import { RelatedApps, RELATED_BY_APP } from '@hypneuronerd/ui';
import type { Draft } from '../data/types';
import { SECTIONS } from '../data/sections';
import styles from './LetterPreview.module.css';

interface LetterPreviewProps {
  draft: Draft;
}

export function LetterPreview({ draft }: LetterPreviewProps) {
  const title = draft.title?.trim() || 'a negotiation letter';

  return (
    <article className={styles.letter} aria-live="polite">
      <div className={styles.seal} aria-hidden="true">
        ✦
      </div>

      <header className={styles.header}>
        <h1 className={styles.title}>{title}</h1>
        {draft.recipient?.trim() && (
          <p className={styles.recipient}>for {draft.recipient.trim()}</p>
        )}
      </header>

      {SECTIONS.map((sec) => {
        const body = draft.sections[sec.key]?.trim();
        const hasBody = body && body.length > 0;
        return (
          <section key={sec.key} className={styles.section}>
            <h2 className={styles.sectionHeading}>{sec.heading}</h2>
            {hasBody ? (
              <p className={styles.body}>{body}</p>
            ) : (
              <p className={styles.placeholder}>{sec.placeholder}</p>
            )}
          </section>
        );
      })}

      <footer className={styles.footer}>
        <p className={styles.divider}>· · ·</p>
        <p className={styles.composedOn}>
          composed on{' '}
          {new Date(draft.updatedAt).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })}
        </p>
      </footer>

      <RelatedApps apps={RELATED_BY_APP['negotiation-letter']} surface="cream" />
    </article>
  );
}
